import { render, staticRenderFns } from "./walletVerify.vue?vue&type=template&id=6f370416&lang=pug&"
import script from "./walletVerify.vue?vue&type=script&lang=js&"
export * from "./walletVerify.vue?vue&type=script&lang=js&"
import style0 from "./walletVerify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports